var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTravel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BoxContent/Header/LeftIcon35") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BoxContent/Header/LeftIcon35",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BoxContent/Header/LeftIcon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F5F5F7",
    opacity: 0,
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.000000, 4.000000)",
    fill: "#181E34",
    opacity: 0.400000006
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,6 C6.209139,6 8,7.790861 8,10 C8,11.4727593 6.66666667,13.4727593 4,16 C1.33333333,13.4727593 0,11.4727593 0,10 C0,7.790861 1.790861,6 4,6 Z M4,8 C2.8954305,8 2,8.8954305 2,10 C2,11.1045695 2.8954305,12 4,12 C5.1045695,12 6,11.1045695 6,10 C6,8.8954305 5.1045695,8 4,8 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape-2",
    transform: "translate(10.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,0 C4.65685425,0 6,1.2536027 6,2.8 C6,3.83093153 5,5.23093153 3,7 C1,5.23093153 0,3.83093153 0,2.8 C0,1.2536027 1.34314575,0 3,0 Z M3,1.4 C2.17157288,1.4 1.5,2.02680135 1.5,2.8 C1.5,3.57319865 2.17157288,4.2 3,4.2 C3.82842712,4.2 4.5,3.57319865 4.5,2.8 C4.5,2.02680135 3.82842712,1.4 3,1.4 Z",
    id: "Combined-Shape"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M17,10.5000838 C14.6666667,11.5000279 13.5,12.5575358 13.5,13.6726074 C13.5,15.3452148 19.0812988,14.3125 19,18.0231934 C19,19.3410645 15.3333333,19.8016604 8,19.4049812",
    id: "Path",
    stroke: "#A3A5AE",
    strokeDasharray: "1,1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTravel);
export default __webpack_public_path__ + "static/media/icon-travel.1aed67f59ee66cecaf0ebe50e3feadc8.svg";
export { ForwardRef as ReactComponent };